<div class="paginator" [class.paginator__border-top]="borderTop" [class.paginator__small-container]="smallContainer">
  <div class="paginator-container">
    <div class="page-size-container">
      @if (pageSizeOptions.length && showSizeSelector) {
        <mat-form-field class="page-size-select" appearance="outline">
          <mat-select [value]="selectedSize()" (selectionChange)="onItemPerPageChange($event.value)">
            @for (size of pageSizeOptions; track size) {
              <mat-option [value]="size">
                {{ size }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="range-actions-container">
      <div class="paginator-label range-label">{{ getFirstElementOfPageIndex() }}-{{ getLastElementOfPageIndex() }} {{ 'Paginator.Of' | translate }} {{ totalLength }}</div>
      <div class="d-flex">
        <button mat-icon-button mat-sm-button [matTooltip]="'Paginator.FirstPage' | translate" (click)="goToFirstPage()" [disabled]="currentPage == 0">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-icon-button mat-sm-button [matTooltip]="'Paginator.PreviousPage' | translate" (click)="goToPreviousPage()" [disabled]="currentPage == 0">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <button mat-icon-button mat-sm-button [matTooltip]="'Paginator.NextPage' | translate" (click)="goToNextPage()" [disabled]="currentPage == getLastPage()">
          <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button mat-sm-button [matTooltip]="'Paginator.LastPage' | translate" (click)="goToLastPage()" [disabled]="currentPage == getLastPage()">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
